import InvoiceCartView from '@/components/Templates/InvoiceCart';

const InvoiceCart = () => {
	return <InvoiceCartView />;
};

export default InvoiceCart;
